import cart from 'lib/cart'

/**
 * @info
 *
 * *The "store/cart" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind cart functionality.
 *
 * *This file*
 * This file outlines "actions". Actions are functions that
 * include logic that, when ready, commits a mutation to the
 * application state. Whereas mutations must be synchronous,
 * actions return a promise and can include asynchronous
 * logical sequences.
 */
export default {
  getCart ({ commit, state, dispatch }, payload) {
    commit('setLoading', true)

    return cart
      .get()
      .then(data => {
        commit('global/refreshCart', data, { root: true })
        commit('setLoading', false)
      })
  },

  updateItemQuantity ({ commit, state, dispatch }, { quantity, id, properties }) {
    if (!id) {
      return
    }

    commit('setLoading', true)

    return cart
      .update({ quantity, id, properties })
      .then(data => {
        dispatch('getCart', data)
        commit('setLoading', false)
        commit('setCart', true)
      })
  },

  openCart ({ commit }) {
    commit('setCart', true)
  },

  toggleCart ({ commit }) {
    commit('toggleCart')
  },

  closeCart ({ commit }) {
    commit('closeCart')
  },

  addToCart ({ commit, dispatch }, { id, quantity, properties, withProperties = false }) {
    return cart
      .add({ quantity, id, properties })
      .then(data => {
        dispatch('getCart', data)
        commit('setLoading', false)
        commit('setCart', true)
      })
  }
}
